   jQuery(".product-grid--title a, .shopify-section > .product-grid-title a").each(function () {
          if (jQuery(this).html().indexOf(":") !== -1) {
            var firstword = jQuery(this).html().split(":")[0];
          } else {
            var firstword = jQuery(this).html().split(" ")[0];
          }
          var nextwords = jQuery(this).html().replace(firstword,"").replace(":","");
          jQuery(this).html('<span class="nt-product-title">'+firstword+'</span><br/>'+'<span class="nt-product-subtitle">'+nextwords+'</span>');
        });
